import { SocialShareType, SocialShareData } from '../types'
import { getConfig } from '../../../config'
import { openShareWindow } from './social-share-window'

const config = getConfig()

const encodeParams = (data: SocialShareData) => ({
  url: encodeURIComponent(data.url),
  text: encodeURIComponent(data.text ?? ''),
  hashtags: encodeURIComponent(data.hashtags ?? ''),
})

const shareHandlers: Record<SocialShareType, (data: SocialShareData) => void> = {
  [SocialShareType.Facebook]: (data) => {
    const { url, text, hashtags } = encodeParams(data)
    // Since we don't have app_id for the new Facebook share URL, we use the old one
    // const shareUrl = `${config.social.facebookShareUrl}?link=${url}&app_id=${config.social.facebookAppId}&redirect_uri=${url}&hashtags=${hashtags}`
    const shareUrl = `${config.social.facebookShareUrlDeprecated}?u=${url}&quote=${text}&title=title&description=description&hashtags=${hashtags}`
    openShareWindow(shareUrl)
  },
  [SocialShareType.FacebookMessenger]: (data) => {
    const { url } = encodeParams(data)
    const shareUrl = `${config.social.facebookMessengerShareUrl}?link=${url}&app_id=${config.social.facebookMessengerAppId}&redirect_uri=${url}`
    openShareWindow(shareUrl)
  },
  [SocialShareType.X]: (data) => {
    const { url, text, hashtags } = encodeParams(data)
    const shareUrl = `${config.social.xShareUrl}?url=${url}&text=${text}&hashtags=${hashtags}`
    openShareWindow(shareUrl)
  },
  [SocialShareType.LinkedIn]: (data) => {
    const { url, text } = encodeParams(data)
    const shareUrl = `${config.social.linkedInShareUrl}?url=${url}&text=${text}`
    openShareWindow(shareUrl)
  },
  [SocialShareType.Instagram]: ({ instagramLink }) => {
    if (!instagramLink) {
      throw new Error('Instagram link is required')
    }
    window.open(instagramLink, '_blank')
  },
  [SocialShareType.Email]: (data) => {
    const { text, url } = data
    try {
      // First try opening the default mail client
      const body = `${text ? `${text}\n\n` : ''}${url}`
      const mailtoUrl = `mailto:?body=${encodeURIComponent(body)}`
      // Using window.location.href = mailtoUrl can cause issues if mail client isn't confisgured
      // Using window.open gives us more control and fallback options
      const mailWindow = window.open(mailtoUrl, '_blank')
      // If mail client failed to open or was blocked
      if (!mailWindow || mailWindow.closed || typeof mailWindow.closed === 'undefined') {
        // Fallback to Gmail
        const gmailUrl = `https://mail.google.com/mail/u/0/?view=cm&fs=1&body=${encodeURIComponent(body)}`
        window.open(gmailUrl, '_blank')
      }
    } catch (error) {
      console.error('Failed to open email client:', error)
    }
  },
}

export function socialShare(type: SocialShareType, data: SocialShareData) {
  const handler = shareHandlers[type]
  if (!handler) {
    throw new Error(`Unknown share type: ${type}`)
  }
  handler(data)
}
